var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-main',{ref:"masterMain",attrs:{"addProperties":{ eventType: 1, routeToCreate: _vm.getModuleRoute },"exportProperties":{
    pdf: {
      filename: `${_vm.$t('devices.blood_pressure_monitors')}_${_vm.dateToday}.pdf`,
      route: `${_vm.getModuleRoute}/pdf`,
    },
    xls: {
      filename: `${_vm.$t('devices.blood_pressure_monitors')}_${_vm.dateToday}.xlsx`,
      route: `${_vm.getModuleRoute}/excel`,
    },
  },"dataBadges":[
    {
      columnLabel: _vm.$t('common_words.company'),
      data: 'businesses',
      property: 'name',
      minWidth: 160,
    },
    {
      columnLabel: _vm.$t('common_words.farm'),
      data: 'farms',
      property: 'name',
      minWidth: 160,
    },
  ],"route":_vm.getModuleRoute,"tableProperties":_vm.tableProperties},on:{"refresh":_vm.refresh,"showHideLoading":_vm.showHideLoading,"showNotification":_vm.notifyVue}})
}
var staticRenderFns = []

export { render, staticRenderFns }